import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {Header, Container, Message, Loader, Button, Segment} from 'semantic-ui-react';

import httpClient from 'httpClient';
import {getShortURLHosts} from 'state/selectors';

import CreateModal from './CreateModal';
import ShortUrlsList from './ShortUrlsList';

import styles from './ShortUrlsPage.module.scss';

const renderContent = (shortUrls, error, isLoading) => {
  if (isLoading) {
    return <Loader inline="centered" active />;
  } else if (error) {
    return (
      <Message error>
        There was a problem while fetching your short URLs:
        <br />
        {error}
      </Message>
    );
  } else if (shortUrls.length === 0) {
    return <Message info>You do not have any short URLs yet.</Message>;
  } else {
    return <ShortUrlsList shortUrls={shortUrls} />;
  }
};

const ShortUrlsPage = () => {
  const shortURLHosts = useSelector(getShortURLHosts);
  const [userShortUrls, setUserShortUrls] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openCreateModal, setOpenCreateModal] = useState(false);

  // GET implemented here to simplify future search implementation
  useEffect(() => {
    async function fetchUrls(hosts) {
      if (hosts === undefined || hosts === null || hosts.length === 0) {
        return;
      }

      try {
        setIsLoading(true);
        const responses = await Promise.all(
          shortURLHosts.map(shortUrlHost =>
            httpClient.get(`/api/web-redirector/${shortUrlHost}/short-urls`)
          )
        );
        const urls = responses.reduce((acc, response) => {
          return acc.concat(response.data.shortUrls);
        }, []);
        setUserShortUrls(urls);
      } catch (err) {
        let errorMessage = '';
        if (err.response.data.errors) {
          errorMessage += ' ' + JSON.stringify(err.response.data.errors.json);
        }
        if (err.response.data.error) {
          errorMessage += ' ' + err.response.data.error;
        }
        setError(errorMessage);
      } finally {
        setIsLoading(false);
      }
    }
    fetchUrls(shortURLHosts);
  }, [shortURLHosts]);

  return (
    <Container className={styles.ShortUrlsPage} textAlign="center">
      <Header className={styles.Header}>
        My short URLs
        <Header.Subheader>
          Use Short URLs to shorten links and share them. The target URL should belong to the
          cern.ch domain and can be modified later on.
        </Header.Subheader>
      </Header>
      <CreateModal
        trigger={
          <Segment textAlign="right" basic>
            <Button
              onClick={() => setOpenCreateModal(true)}
              className={styles.ActionButton}
              disabled={isLoading}
            >
              Create
            </Button>
          </Segment>
        }
        open={openCreateModal}
        onCreate={() => {
          setOpenCreateModal(false);
        }}
        onClose={() => {
          setOpenCreateModal(false);
        }}
      />
      {renderContent(userShortUrls, error, isLoading)}
    </Container>
  );
};

export default ShortUrlsPage;
